/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { Component, Fragment } from 'react';

import { withStyles } from '@material-ui/core/styles'
import clsx from "clsx";

import { Paper, Typography, IconButton } from '@material-ui/core'

import add from "date-fns/add"
import DateFnsUtils from '@date-io/date-fns'; 
import { DatePicker, MuiPickersUtilsProvider} from "@material-ui/pickers";
import { format, isSameDay, isWithinInterval, startOfWeek, endOfWeek } from 'date-fns'

const styles = theme => ({
    dayWrapper: {
        position: "relative",
    },
    day: {
        width: 36,
        height: 36,
        fontSize: theme.typography.caption.fontSize,
        margin: "0 2px",
        color: "inherit",
    },
    customDayHighlight: {
        position: "absolute",
        top: 0,
        bottom: 0,
        left: "2px",
        right: "2px",
        border: `1px solid ${theme.palette.secondary.main}`,
        borderRadius: "50%",
    },
    nonCurrentMonthDay: {
        color: theme.palette.text.disabled,
    },
    highlightNonCurrentMonthDay: {
        color: "#676767",
    },
    highlight: {
        background: theme.palette.primary.main,
        color: theme.palette.common.white,
    },
    firstHighlight: {
        extend: "highlight",
        borderTopLeftRadius: "50%",
        borderBottomLeftRadius: "50%",
    },
    endHighlight: {
        extend: "highlight",
        borderTopRightRadius: "50%",
        borderBottomRightRadius: "50%",
    },
})

class WeekRangePicker extends Component {
    state = {  }


    renderWrappedWeekDay = (date, selectedDate, dayInCurrentMonth, dayComponent) => {
        const { classes } = this.props;
        let dateClone = new Date(date);
        let selectedDateClone = new Date(selectedDate);
    
        const start = startOfWeek(selectedDateClone);
        const end = endOfWeek(selectedDateClone);
    
        const dayIsBetween = isWithinInterval(dateClone, { start, end });
        const isFirstDay = isSameDay(dateClone, start);
        const isLastDay = isSameDay(dateClone, end);
    
        const wrapperClassName = clsx({
          [classes.highlight]: dayIsBetween,
          [classes.firstHighlight]: isFirstDay,
          [classes.endHighlight]: isLastDay,
        });
    
        const dayClassName = clsx(classes.day, {
          [classes.nonCurrentMonthDay]: !dayInCurrentMonth,
          [classes.highlightNonCurrentMonthDay]: !dayInCurrentMonth && dayIsBetween,
        });
    
        // return (
        //   <div className={wrapperClassName}>
        //     <IconButton className={dayClassName}>
        //       <span> {format(dateClone, "d")} </span>
        //     </IconButton>
        //   </div>
        // );

        return (
            <div className={wrapperClassName}>
                {dayComponent}
            </div>
          );
    };

    getMaxDate = () => {
        if (this.props.filter.start_date !== null) {
            let max_date = add(new Date(this.props.filter.start_date), {
                years: 0,
                months: 0,
                weeks: 11,
                days: 6,
                hours: 0,
                minutes: 0,
                seconds: 0,
            })
            console.log("Max Date :", max_date)
            return max_date
        }
    }

    updateValue = (date, position) => {
        if (position === 'start_date') {
            let value =  format(startOfWeek(date, {weekStartsOn : 0}), "yyyy-MM-dd'T'HH:mm:ssxxx")
            this.props.update_filter(position, value)
        }

        if (position === 'end_date') {
            let value =  format(endOfWeek(date, {weekStartsOn : 0}), "yyyy-MM-dd'T'HH:mm:ssxxx")
            this.props.update_filter(position, value)
        }
    }

    render() {
        return (
            <Fragment>
                <Typography style = {{marginLeft : '5px'}} variant = 'caption' color = 'secondary'><em>Maximum weekly interval allowed is 12 weeks</em></Typography>
                <div style = {{display : 'flex', flexDirection : 'row'}}>
                    <div style = {{margin : '5px'}}>
                        <Typography variant = 'subtitle2' color = 'primary'>From</Typography>
                        <Paper square elevation = {2}>
                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                <DatePicker
                                    autoOk
                                    orientation="landscape"
                                    variant="static"
                                    openTo="date"
                                    value = {this.props.filter.start_date}
                                    renderDay={this.renderWrappedWeekDay}
                                    onChange = {(value) => this.updateValue(value, 'start_date')}
                                />
                            </MuiPickersUtilsProvider>
                        </Paper>
                    </div>
                    <div style = {{margin : '5px'}}>
                        <Typography variant = 'subtitle2' color = 'primary'>To</Typography>
                        <Paper square elevation = {2}>
                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                <DatePicker
                                    autoOk
                                    orientation="landscape"
                                    variant="static"
                                    openTo="date"
                                    minDate = {new Date(this.props.filter.start_date)}
                                    maxDate = {this.getMaxDate()}
                                    disableFuture
                                    value = {this.props.filter.end_date}
                                    renderDay={this.renderWrappedWeekDay}
                                    onChange = {(value) => this.updateValue(value, 'end_date')}
                                />
                            </MuiPickersUtilsProvider>
                        </Paper>
                    </div>
                </div>
            </Fragment>
        );
    }
}

export default withStyles(styles)(WeekRangePicker);